import { isMonthDayWithinRange } from '@sola/utils/date.ts';

// US tax season window (inclusive). 4/15 is the filing deadline; we run one day
// past it and ignore extension filers.
export const TAX_SEASON_START_MONTH_DAY = '01-19'; // January 19
export const TAX_SEASON_END_MONTH_DAY = '04-15'; // April 15

export const isDuringTaxSeason = (value: Date = new Date()): boolean =>
  isMonthDayWithinRange(
    TAX_SEASON_START_MONTH_DAY,
    TAX_SEASON_END_MONTH_DAY,
    value,
  );

export const CHRISTMAS_APPEAL_START_MONTH = 10; // October
export const CHRISTMAS_APPEAL_END_MONTH = 12; // December
export const CHRISTMAS_ONE_TIME_LOOKBACK_MONTHS = 3;

export const isDuringChristmasAppealSeason = (
  value: Date = new Date(),
): boolean => {
  const month = value.getMonth() + 1;

  return (
    month >= CHRISTMAS_APPEAL_START_MONTH && month <= CHRISTMAS_APPEAL_END_MONTH
  );
};
